import { QuoteElement } from "../../lib/quote-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { formatCurrency } from "../../lib/utils.js";
import { css, html } from "lit";
import { property, state, customElement } from "lit/decorators.js";
import "../../common/offer-add-button.js";
import { when } from "lit/directives/when.js";
import { classMap } from "lit/directives/class-map.js";
import packageOfferStyles from "../../lib/package-offer-styles.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let PetInsurancePackage = class extends QuoteElement {
  constructor() {
    super("pet-insurance");
    this.annualLimit = 1e4;
    this.deductibleAmount = 500;
    this.recommended = false;
    this.disabled = false;
    this.breedSchema = void 0;
    this.breedNotFound = false;
  }
  /**
   * @ignore
   */
  get policyAttributes() {
    if (this.breedId) {
      return {
        species: this.species,
        breed_id: this.breedId,
        pet_name: this.petName,
        age: this.age,
        gender: this.gender,
        zip_code: this.customerPostalCode,
        coverage_type: this.plan,
        annual_limit: this.annualLimit,
        deductible_amount: this.deductibleAmount
      };
    }
    return {};
  }
  toggleOfferSelection() {
    if (this.selectedState === SelectedState.ACCEPTED) {
      this.selectedState = SelectedState.UNKNOWN;
      this.triggerOfferStateChangeEvent();
    } else {
      this.accept();
    }
  }
  render() {
    return this.quoteController.render({
      complete: () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return html`
        <div id="offer-display" class=${classMap({ "selected": this.selectedState === SelectedState.ACCEPTED, disabled: this.disabled })}>
          ${when(this.recommended, () => html`<div id="offer-tag">Most Popular</div>`)}
          <offer-header .quote=${this.quote}>
            ${((_b = (_a = this.quote) == null ? void 0 : _a.subscription_premium) == null ? void 0 : _b.payment_amount) ? formatCurrency((_d = (_c = this.quote) == null ? void 0 : _c.subscription_premium) == null ? void 0 : _d.payment_amount, this.quote.currency) + "/mo" : ""}
          </offer-header>
          <offer-accordion-header @change=${this.toggleOfferSelection} .checked=${this.selectedState === SelectedState.ACCEPTED}  .quote=${this.quote}>
            ${((_f = (_e = this.quote) == null ? void 0 : _e.subscription_premium) == null ? void 0 : _f.payment_amount) ? formatCurrency((_h = (_g = this.quote) == null ? void 0 : _g.subscription_premium) == null ? void 0 : _h.payment_amount, this.quote.currency) + "/mo" : ""}
          </offer-accordion-header>
          <promotional-description .quote=${this.quote}></promotional-description>
          <section id="offer-content">
            <peril-list .quote=${this.quote} .declined=${this.selectedState === SelectedState.DECLINED}></peril-list>
            <section id="actions">
              <offer-add-button 
                @click=${this.toggleOfferSelection} 
                .disabled=${this.disabled}
                .selected=${this.selectedState === SelectedState.ACCEPTED}
                .addLabel=${"Select Plan"}
                .removeLabel=${"Remove Plan"}
              >
              </offer-add-button>
            </section>
          </section>
        </div>
    `;
      }
    });
  }
};
PetInsurancePackage.styles = [
  QuoteElement.styles,
  packageOfferStyles,
  css`
      :host {
        margin: unset;
      }

      #offer-display promotional-description {
        display: none;
      }

      #offer-display.disabled {
        opacity: 20%;
      }

      @media (max-width: 830px) {
        #offer-display {
          padding: 16px;
        }
    
        #offer-display offer-header { 
          display: none;
        }
    
        #offer-display offer-radio-header { 
          display: none;
        }
    
        #offer-display offer-accordion-header, 
        #offer-display.selected offer-accordion-header  {
          display: block;
        }
    
        #offer-display section#actions {
          display: none;
        }
    
        #offer-display #offer-content {
          display: none;
        }
    
        #offer-tag {
          display: none;
        }
    
        #offer-display promotional-description, 
        #offer-display #offer-content peril-list {
          display: none;
        }
    
        #offer-display.selected promotional-description, 
        #offer-display.selected #offer-content,
        #offer-display.selected #offer-content peril-list {
          display: block;
        }
      }
    `
];
__decorateClass([
  property({ attribute: "species" })
], PetInsurancePackage.prototype, "species", 2);
__decorateClass([
  property({ attribute: "plan" })
], PetInsurancePackage.prototype, "plan", 2);
__decorateClass([
  property({ attribute: "declared-breed" })
], PetInsurancePackage.prototype, "declaredBreed", 2);
__decorateClass([
  property({ attribute: "pet-name" })
], PetInsurancePackage.prototype, "petName", 2);
__decorateClass([
  property({ type: Number, attribute: "age" })
], PetInsurancePackage.prototype, "age", 2);
__decorateClass([
  property({ attribute: "gender" })
], PetInsurancePackage.prototype, "gender", 2);
__decorateClass([
  property({ type: Number, attribute: "annual-limit" })
], PetInsurancePackage.prototype, "annualLimit", 2);
__decorateClass([
  property({ type: Number, attribute: "deductible-amount" })
], PetInsurancePackage.prototype, "deductibleAmount", 2);
__decorateClass([
  property({ type: Boolean })
], PetInsurancePackage.prototype, "recommended", 2);
__decorateClass([
  property({ type: Boolean })
], PetInsurancePackage.prototype, "disabled", 2);
__decorateClass([
  state()
], PetInsurancePackage.prototype, "breedSchema", 2);
__decorateClass([
  property()
], PetInsurancePackage.prototype, "breedId", 2);
__decorateClass([
  state()
], PetInsurancePackage.prototype, "breedNotFound", 2);
PetInsurancePackage = __decorateClass([
  customElement("pet-insurance-plan")
], PetInsurancePackage);
export {
  PetInsurancePackage
};
